import React from "react";
import { Facebook, Twitter, Instagram, Linkedin, ArrowUp, MapPin, Phone, Mail, ShieldCheck, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const currentYear = new Date().getFullYear();
  const quickLinks = [{
    label: "Home",
    to: "/HomePage"
  }, {
    label: "Project Gallery",
    to: "/ProjectGalleryPage"
  }, {
    label: "Request Quote",
    to: "/RequestQuotePage"
  }];
  const services = ["Concrete Sealing", "Stone Restoration", "Waterproofing", "Industrial Coatings", "Surface Protection"];
  const socialIcons = [{
    Icon: Facebook,
    label: "Facebook",
    to: "https://facebook.com"
  }, {
    Icon: Twitter,
    label: "Twitter",
    to: "https://twitter.com"
  }, {
    Icon: Instagram,
    label: "Instagram",
    to: "https://instagram.com"
  }, {
    Icon: Linkedin,
    label: "LinkedIn",
    to: "https://linkedin.com"
  }];
  return <section data-section-id="19555" id="footer" className="bg-sidebar text-sidebar-foreground pt-20 pb-10 relative overflow-hidden border-t border-sidebar-border">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-sidebar-ring/50 to-transparent opacity-50" />
      
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570251/img/iconic_field_service_logo_white.png" alt="Island Seals Logo" className="h-10 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity" />
            </Link>
            <div className="space-y-4">
              <p className="text-sidebar-foreground/60 text-sm leading-relaxed max-w-xs tracking-tight">
                Professional sealing and waterproofing solutions designed to protect and preserve your concrete and stone surfaces with industrial-grade precision.
              </p>
              
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-bold tracking-tighter uppercase text-sidebar-foreground">Quick Links</h3>
            <nav className="flex flex-col space-y-3">
              {quickLinks.map((link, i) => <div key={i} data-index={i}>
                  <Link to={link.to} className="text-sidebar-foreground/60 hover:text-white transition-colors text-sm inline-flex items-center gap-2 group tracking-tight">
                    <ChevronRight className="w-3 h-3 text-sidebar-border group-hover:text-sidebar-ring transition-colors" />
                    {link.label}
                  </Link>
                </div>)}
            </nav>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-bold tracking-tighter uppercase text-sidebar-foreground">Services</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i} className="text-sidebar-foreground/60 text-sm flex items-start gap-2 hover:text-white transition-colors cursor-default tracking-tight">
                  <span className="w-1.5 h-1.5 rounded-full bg-sidebar-ring/50 mt-1.5 shrink-0" />
                  {service}
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-bold tracking-tighter uppercase text-sidebar-foreground">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3 text-sidebar-foreground/60 text-sm group tracking-tight">
                <MapPin className="w-4 h-4 text-sidebar-ring shrink-0 mt-0.5 group-hover:text-white transition-colors" />
                <span>5249 Miller Rd. Duncan, BC</span>
              </div>
              <div className="flex items-center gap-3 text-sidebar-foreground/60 text-sm group tracking-tight">
                <Phone className="w-4 h-4 text-sidebar-ring shrink-0 group-hover:text-white transition-colors" />
                <Link to="tel:2505550199" className="hover:text-white transition-colors">12505104254</Link>
              </div>
              <div className="flex items-center gap-3 text-sidebar-foreground/60 text-sm group tracking-tight">
                <Mail className="w-4 h-4 text-sidebar-ring shrink-0 group-hover:text-white transition-colors" />
                <Link to="mailto:islandseals@outlook.com" className="hover:text-white transition-colors">islandseals@outlook.com</Link>
              </div>
            </div>
            
            <div className="pt-4 flex gap-3">
              {socialIcons.map(({
              Icon,
              label,
              to
            }, i) => <Link key={i} data-index={i} to={to} newTab className="w-9 h-9 rounded-sm bg-sidebar-accent/50 flex items-center justify-center text-sidebar-foreground/60 hover:bg-sidebar-ring hover:text-white transition-all duration-300 border border-sidebar-border/50 hover:border-sidebar-ring hover:-translate-y-0.5 shadow-sm" aria-label={label}>
                  <Icon className="w-4 h-4" />
                </Link>)}
            </div>
          </div>
        </div>

        <Separator className="bg-sidebar-border/30 mb-8" />

        {}
        <div className="flex flex-col-reverse md:flex-row justify-between items-center gap-6 text-xs text-sidebar-foreground/40 font-medium tracking-wider uppercase">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
            <p>© {currentYear} Island Seals. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="#" className="hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="#" className="hover:text-white transition-colors">Terms of Service</Link>
            </div>
          </div>
          
          <Button variant="outline" size="sm" onClick={scrollToTop} className="rounded-sm bg-sidebar-accent/20 border-sidebar-border/30 text-sidebar-foreground/80 hover:bg-sidebar-ring hover:text-white hover:border-sidebar-ring transition-all gap-2 pl-4 pr-4 h-8 text-[10px] font-bold uppercase">
            Back to Top
            <ArrowUp className="w-3 h-3" />
          </Button>
        </div>
      </div>
    </section>;
}